import colors, { darkThemeColors } from '@theme/colors';

export const darkPalette = {
  background: {
    main: 'hsl(212 37% 19% / 1)',
    paper: '#00000000',
    secondary: colors.SUN_YELLOW_SUPPLEMENTAL,
    primary: colors.NAVY,
    light: colors.FADED_NAVY,

    // used all over in lio so we need it - other themes would probably not be a gradient
    gradient: colors.NAVY,
  },
  panel: {
    light: 'rgba(255, 255, 255, 0.04)',
    main: colors.WHITE_10,
    dark: colors.BLACK_10,
  },
  drawerNavigation: {
    main: '#23384f',
    light: '#36506D',
    alt: colors.NAVY,
  },
  secondary: {
    light: colors.SUN_YELLOW,
    main: colors.SUN_YELLOW_SUPPLEMENTAL,
    dark: colors.DARK_SEAFOAM,
    alt: colors.SKY_BLUE,
  },
  actions: {
    icon: colors.NAVY,
  },
  text: {
    main: colors.WHITE_100,

    disabled: colors.WHITE_60,
    subdued: colors.WHITE_60,

    secondary: colors.WHITE_80,
    caption: colors.WHITE_80,

    placeholder: colors.WHITE_30,
  },
  button: {
    tertiary: colors.SUN_YELLOW_SUPPLEMENTAL,
    tertiaryDark: colors.SEAFOAM_SUPPLEMENTAL,
    outlinedDark: colors.WHITE_100,
    outlined: colors.NAVY,
    containedDisabledText: colors.WHITE_60,
  },
  other: {
    success: colors.DARK_SUCCESS,
    error: colors.DARK_ERROR,
    divider: colors.WHITE_30,
    highlight: colors.SEAFOAM,
    bindIncomplete: colors.DARK_BIND_INCOMPLETE,
  },

  info: {
    main: colors.LIGHT_SKY_BLUE,
    dark: colors.SKY_BLUE,
    hover: colors.WHITE_20,
    hint: colors.WHITE_80,
  },
  success: {
    main: colors.DARK_SUCCESS,
    light: colors.DARK_SUCCESS,
    default: colors.DARK_SUCCESS,
  },
  error: {
    light: colors.DARK_ERROR,
    main: colors.DARK_ERROR,
    default: colors.DARK_ERROR,
  },
  warning: {
    main: colors.SUN_YELLOW,
    dark: colors.SUN_YELLOW,
  },
  primary: {
    // this is bad use of colors but needed for ow
    main: colors.NAVY,
    dark: darkThemeColors.TOOLTIP_BACKGROUND,
    light: colors.FADED_NAVY_HOVER,
  },
  icon: {
    dark: colors.WHITE_100,
    disabled: colors.WHITE_20,
  },
  accent: {
    secondary: colors.CORAL,
    tertiary: colors.SUN_YELLOW_SUPPLEMENTAL,
  },
  border: {
    light: colors.WHITE_10,
    main: colors.BLACK_25,
  },
  dataGrid: {
    background: '#364456',
    borderLeft: colors.SEAFOAM,
    columnHeaderSorted: colors.SUN_YELLOW_SUPPLEMENTAL,
  },
};
